module.exports = __webpack_public_path__ + "images/settings@2x.png?cf8a97c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settings@2x.png
// module id = 699
// module chunks = 7